import {
  type MutationFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { removeEmpty, useAdminParams } from 'utils/helpers';
import useModal from 'ui/partials/Modal/useModal';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Company } from 'utils/types';
import partialConstants from 'ui/partials/utils/constants';

import c from '../utils/constants';

export default function useUpdateCompany() {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  const mutationFn: MutationFunction<any, any> = async ({ id, ...payload }) => {
    const api = new Api(args);

    const data = await api.patch(
      await withAcl({
        account: {
          url: `api/v1/contacts/companies/${id}`,
          payload: removeEmpty(payload),
        },
        admin: {
          url: `api/v2/accounts/${accountId}/users/${accountUserId}/contacts/companies/${id}`,
          payload: removeEmpty(payload),
        },
      }),
    );

    return data?.data;
  };

  return useMutation<Company, ApiError, any, any>({
    mutationFn,
    onSuccess: ({ id }, { leadId }) => {
      queryClient.invalidateQueries({
        queryKey: [c.COMPANIES, id],
      });
      queryClient.invalidateQueries({
        queryKey: [c.COMPANIES, {}],
      });
      queryClient.invalidateQueries({
        queryKey: [c.COMPANIES, {}],
      });
      queryClient.invalidateQueries({
        queryKey: [c.LOGS, id],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      if (leadId !== undefined) {
        queryClient.invalidateQueries({
          queryKey: [c.LEADS],
        });
      }

      hideModal();
      toastSuccess('Successfully updated company');
    },
  });
}
